import { IconProps } from 'components/Shared/Icon';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

// tslint:disable: max-line-length
export const IconBasket = (props: IconProps) => (
  <svg
    className={iconStyles(props)}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.4409 14.955C23.9311 15.885 22.9415 16.5 21.8169 16.5H10.646L8.99666 19.5H26.99V22.5H8.99666C6.71751 22.5 5.27804 20.055 6.37263 18.045L8.39688 14.385L2.99889 3H0V0H4.90318L6.31266 3H28.5044C29.644 3 30.3637 4.23 29.8089 5.22L24.4409 14.955ZM25.9554 6H7.73713L11.2908 13.5H21.8169L25.9554 6ZM8.99666 24C7.34727 24 6.01277 25.35 6.01277 27C6.01277 28.65 7.34727 30 8.99666 30C10.646 30 11.9955 28.65 11.9955 27C11.9955 25.35 10.646 24 8.99666 24ZM21.0072 27C21.0072 25.35 22.3417 24 23.9911 24C25.6405 24 26.99 25.35 26.99 27C26.99 28.65 25.6405 30 23.9911 30C22.3417 30 21.0072 28.65 21.0072 27Z"
      stroke="none"
    />
  </svg>
);
